import { Route, Routes } from 'react-router-dom';
import RabHome from './Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/rab/home" element={<RabHome />} />
    </Routes>
  );
}

export default Router;
